import React from 'react';
import { FlowerIcon } from 'lucide-react';
export function Logo({
  className = 'h-8 w-auto'
}) {
  return <div className="flex items-center" data-id="element-272">
      <div className="bg-pink-50 p-1.5 rounded-full" data-id="element-273">
        <FlowerIcon className="h-6 w-6 text-pink-700" data-id="element-274" />
      </div>
      <span className="ml-2 text-xl font-bold text-pink-700" data-id="element-275">
        Sunton Florist
      </span>
    </div>;
}